require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./research-preclinical-xenograft-cancer-models.json") })
        }
      }, "path---research-preclinical-xenograft-cancer-models");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---research-preclinical-xenograft-cancer-models!./.cache/json/research-preclinical-xenograft-cancer-models.json
// module id = 488
// module chunks = 231608221292675